import React, { Component } from "react";
import { connect } from 'react-redux';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import { forgotPwdAction } from 'actions/adminActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  Input,
  InputGroupText,
  InputGroup
} from "reactstrap";

class AdminLoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false
    }
  }

  componentWillMount() {
    document.title = 'Forgot Password';
  }

  componentWillUnmount() {
    if(this.props.response.admin.response !== 'undefined')
      delete this.props.response.admin.response;
  }

  render() {
    let message = '';

    if (this.props.response.admin.hasOwnProperty('response')) {
      if(this.props.response.admin.response &&
          this.props.response.admin.response.hasOwnProperty('message') &&
          this.props.response.admin.response.message)
        message = this.props.response.admin.response.message;
    }

    return (      
      <Formik
        initialValues={{
            email: ''
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
                .required('email is required')
                .email('email is invalid'),
        })}
        onSubmit={fields => {
            let email = fields.email;            
            
            const data = {email}
            this.props.dispatch(forgotPwdAction(data));
        }  
      }
        render={({ errors, status, touched }) => (                    
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Forgot Password                            
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                    <div style={{color: "red"}}>{message}</div><br/>
                      <Form>
                      <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                            <InputGroupText>
                            email
                            </InputGroupText>                          
                          <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                          <ErrorMessage name="email" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <div className="col text-center">
                  <button type="submit" size="lg" outline className="btn btn-primary">Submit</button>
                  </div>
                      </Form>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)(AdminLoginPage);